var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConfirm = function SvgConfirm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 35.5C2.5 17.2746 17.2746 2.5 35.5 2.5C53.7254 2.5 68.5 17.2746 68.5 35.5C68.5 53.7254 53.7254 68.5 35.5 68.5C17.2746 68.5 2.5 53.7254 2.5 35.5Z",
    stroke: "#1D386C",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5579 49.2444C31.0077 49.306 30.4555 49.1461 30.0234 48.8L20.1049 40.8547C19.2069 40.1354 19.0621 38.8243 19.7815 37.9263C20.5008 37.0283 21.8119 36.8834 22.7099 37.6028L30.9972 44.2413L48.0391 22.8263C48.7556 21.926 50.0662 21.7769 50.9665 22.4934C51.8668 23.2099 52.0159 24.5205 51.2994 25.4208L32.956 48.4712C32.6112 48.9045 32.1082 49.1827 31.5579 49.2444Z",
    fill: "#1D386C",
    stroke: "#1D386C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfirm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirm.21949de9.svg";
export { ForwardRef as ReactComponent };